import { Button as BPButton, IButtonProps } from '@blueprintjs/core'
import React, { HTMLProps, SFC } from 'react'
import { Link } from 'react-router-dom'

type Props = {
  to?: string
  external?: boolean
} & IButtonProps &
  HTMLProps<any>

const Button: SFC<Props> = ({ children, to, onClick, external, ...rest }) => {
  if (external) {
    return (
      <a target="_blank" href={to}>
        <BPButton {...rest}>{children}</BPButton>
      </a>
    )
  }

  if (to) {
    return (
      <Link to={to}>
        <BPButton {...rest}>{children}</BPButton>
      </Link>
    )
  }

  return (
    <BPButton {...rest} onClick={onClick}>
      {children}
    </BPButton>
  )
}

export { Button }



// WEBPACK FOOTER //
// ./src/app/shared/components/button.tsx